import { WeekParity } from '.';

// export const getParity = (date?: Date): WeekParity => {
//   const currentDate = date ? date : new Date();
//   const currentYear = currentDate.getFullYear();

//   const timeDifference =
//     currentDate.getTime() - new Date(currentYear, 8, 1).getTime();

//   const weeksDifference = Math.floor(
//     timeDifference / (1000 * 60 * 60 * 24 * 7),
//   );
//   return weeksDifference % 2 === 0 ? WeekParity.Even : WeekParity.Odd;
// };

export const getParity = (date?: Date): WeekParity => {
  const currentDate = date ? new Date(date) : new Date();

  // Начало учебного года (1 сентября)
  let year = currentDate.getFullYear();
  let academicYearStart = new Date(year, 8, 1); // Сентябрь - месяц 8 (0-indexed)

  // Если текущая дата раньше 1 сентября, используем предыдущий год
  if (currentDate < academicYearStart) {
    academicYearStart = new Date(year - 1, 8, 1);
    year = year - 1;
  }

  // Функция для получения понедельника текущей недели
  const getMonday = (d: Date): Date => {
    const date = new Date(d);
    const day = date.getDay(); // 0 - воскресенье, 1 - понедельник, ..., 6 - суббота
    const diff = day === 0 ? 6 : day - 1; // Если воскресенье (0), отнимаем 6 дней до понедельника
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
  };

  // Получаем понедельник для текущей даты и для начала учебного года
  const currentMonday = getMonday(currentDate);
  const startMonday = getMonday(academicYearStart);

  // Разница в днях между понедельниками
  const diffTime = currentMonday.getTime() - startMonday.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  // Количество недель
  const weeksDifference = Math.floor(diffDays / 7);

  return weeksDifference % 2 === 0 ? WeekParity.Even : WeekParity.Odd;
};
